import Icon from "./icon-base";
import {
	textMarker,
	genGoogleIcon
} from "@/data/map-markers";
import { gmapApi } from "vue2-google-maps";

export default {
	name: "KTrucksMapScheduleIcon",

	mixins: [ Icon ],

	computed: {
		google: gmapApi,

		marker() {
			const scheduleTypes = this.schedule.scheduleTypeNames.toLowerCase();
			let iconText = scheduleTypes;

			if ( scheduleTypes.indexOf( "delivery" ) !== -1 ) {
				iconText = "D";
			} else if ( scheduleTypes.indexOf( "pickup" ) !== -1 ) {
				iconText = "P";
			} else if ( scheduleTypes.indexOf( "return" ) !== -1 ) {
				iconText = "R";
			} else if ( scheduleTypes.indexOf( "maintenance" ) !== -1 ) {
				iconText = "M";
			}

			return genGoogleIcon(
				this.google,
				textMarker( iconText, "#9CCC65", "#33691E", 24 )
			);
		}
	}
};
